import { BodyText } from '../BodyText';
import { TitleText } from '../TitleText';
import { ZeroStateContainer, ZeroStateContent } from '../ZeroStateUpload/ZeroStateContainer';
import { AiTwotoneControl } from 'react-icons/ai';

export const ReportZeroState = ({ title, description }: { title: string; description?: string }) => (
  <ZeroStateContainer>
    <ZeroStateContent>
      <AiTwotoneControl size={80} color={'text.primary'} />
      <TitleText sx={{ marginBottom: '8px' }}>{title}</TitleText>
      {description && <BodyText color='text.secondary'>{description}</BodyText>}
    </ZeroStateContent>
  </ZeroStateContainer>
);
